import React, { useState } from 'react';
import './ShareModal.css';

const ShareModal = ({ onClose }) => {
    const [shareLink, setShareLink] = useState('https://app.example.com/shared-report/abc123');
    const [emailInput, setEmailInput] = useState('');
    const [phoneInput, setPhoneInput] = useState('');
    const [shareMethod, setShareMethod] = useState('link');
    const [copied, setCopied] = useState(false);

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleShare = () => {
        switch(shareMethod) {
            case 'email':
                console.log(`Sharing via email to: ${emailInput}`);
                break;
            case 'sms':
                console.log(`Sharing via SMS to: ${phoneInput}`);
                break;
            default:
                console.log('Sharing via link');
        }
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content share-modal">
                <div className="modal-header">
                    <h3>Share Report</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                
                <div className="modal-body">
                    <div className="share-methods">
                        <button 
                            className={`share-method-btn ${shareMethod === 'link' ? 'active' : ''}`}
                            onClick={() => setShareMethod('link')}
                        >
                            <span className="method-icon">🔗</span>
                            Share Link
                        </button>
                        <button 
                            className={`share-method-btn ${shareMethod === 'email' ? 'active' : ''}`}
                            onClick={() => setShareMethod('email')}
                        >
                            <span className="method-icon">📧</span>
                            Email
                        </button>
                        <button 
                            className={`share-method-btn ${shareMethod === 'sms' ? 'active' : ''}`}
                            onClick={() => setShareMethod('sms')}
                        >
                            <span className="method-icon">📱</span>
                            SMS
                        </button>
                    </div>

                    {shareMethod === 'link' && (
                        <div className="share-link-section">
                            <div className="link-input-group">
                                <input 
                                    type="text" 
                                    value={shareLink} 
                                    readOnly 
                                    className="link-input"
                                />
                                <button 
                                    className="copy-btn"
                                    onClick={handleCopyLink}
                                >
                                    {copied ? 'Copied!' : 'Copy'}
                                </button>
                            </div>
                            <p className="link-info">This link will expire in 7 days</p>
                        </div>
                    )}

                    {shareMethod === 'email' && (
                        <div className="share-email-section">
                            <div className="form-group">
                                <label>Email Address</label>
                                <input 
                                    type="email" 
                                    value={emailInput}
                                    onChange={(e) => setEmailInput(e.target.value)}
                                    placeholder="Enter email address"
                                />
                            </div>
                        </div>
                    )}

                    {shareMethod === 'sms' && (
                        <div className="share-sms-section">
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input 
                                    type="tel" 
                                    value={phoneInput}
                                    onChange={(e) => setPhoneInput(e.target.value)}
                                    placeholder="Enter phone number"
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="modal-footer">
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                    <button className="share-btn" onClick={handleShare}>
                        Share Report
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShareModal; 